import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

type listDeadAnimalSizesResponse = {
  deadAnimalSizes: string[];
};

export const listDeadAnimalSizes = async () => {
  const response = await executeApiRequest(() => axios.get<listDeadAnimalSizesResponse>("/requests/deadAnimalSizes"));
  return response?.data.deadAnimalSizes;
};
